import React, {useState} from "react";
import style from "./SideBar.module.css";
import {Button} from "react-bootstrap";
import * as GroupGameService from "../../api/GroupGameService"
import {useTranslation} from "react-i18next";
export default function HistoryEndGameTile(props) {
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'historyEndGameTile' });
    const [hide, setHide] = useState(false)

    function hideMessage() {
        setHide(!hide)
    }
    function continueGameFromEarth() {
        setHide(true)
        GroupGameService.callContinueEndedGame(props.gameState.id, props.selectedPlayer.id, () => {}, (response)=>{
            const contentType = response.headers.get('content-type')
            if (contentType && contentType.includes('application/json')) {
                response.json().then(
                    (json) => {
                        window.alert(json.error)
                    }
                )
            }
        })
    }

    return (
        <div className={style.historyRowEndGameTile}>
            {/*Regular game section*/}
            {!props.gameState?.is_trial_game && <div className={style.historyRowEndGameitem}>{t('gameEnd')}</div>}
            {props.role === "mentor" && !props.gameState?.is_trial_game && !hide &&
                <>
                    <div className={style.historyRowEndGameitem}>{t('continueQ')}</div>
                    <div className={style.historyRowEndGameitem}>
                        <Button
                            variant="primary"
                            style={{backgroundColor: "#59619B", margin: "5px", width: "60px"}}
                            onClick={continueGameFromEarth}
                        > {t('yes')} </Button>
                        <Button
                            variant="primary"
                            style={{backgroundColor: "#59619B", margin: "5px", width: "60px"}}
                            onClick={hideMessage}
                        > {t('no')} </Button>
                    </div>
                </>
            }
            {/*END Regular game section*/}
        </div>
    )
}